import { createTheme } from '@mui/material/styles';

// Brand colours come from the logo artwork (see App.css :root). Teal is used at
// its darker text-safe shade here because MUI puts palette colours on text and
// outlines; the logo teal is only 3.3:1 on white.
const navy = '#123871';
const teal = '#00767a';

const theme = createTheme({
  palette: {
    primary: { main: navy, dark: '#0c2a57', light: '#3a5a8f', contrastText: '#fff' },
    secondary: { main: teal, dark: '#005f62', light: '#009da1', contrastText: '#fff' },
    success: { main: '#067647' },
    error: { main: '#b42318' },
    warning: { main: '#b54708' },
    background: { default: '#f5f7fa', paper: '#ffffff' },
    text: { primary: '#16202e', secondary: '#5f6b7a' },
    divider: '#e2e7ee',
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontSize: 14,
    button: { textTransform: 'none', fontWeight: 600 },
    h5: { fontWeight: 700, letterSpacing: '-0.01em' },
    h6: { fontWeight: 650 },
    overline: { fontWeight: 700, letterSpacing: '0.08em' },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { borderRadius: 8 } },
    },
    MuiCard: {
      defaultProps: { variant: 'outlined' },
      styleOverrides: { root: { borderRadius: 14, borderColor: '#e2e7ee' } },
    },
    MuiTab: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 600, minHeight: 60, fontSize: 14 },
      },
    },
    MuiTooltip: { defaultProps: { arrow: true } },
    MuiChip: { styleOverrides: { root: { fontWeight: 600 } } },
  },
});

export default theme;
